export default __webpack_public_path__ + "static/gallery_xl_5-886cd65b07734835b8bcdc4cb6e2cb5b.jpg";